import { FileUploader } from "react-drag-drop-files";
import { useSelector, useDispatch } from 'react-redux'
import { CloudUploadOutlined } from '@ant-design/icons';
import DownloadIcon from '@mui/icons-material/Download';
import Tooltip from '@mui/material/Tooltip';
import Alert from '@mui/material/Alert';
import { useEffect } from 'react';
import { Upload } from 'antd';
import {
  setFile, getFilename, getStyle, getBizID, getObjective, getFileAlertShow, getFileAlertMessage, getFileAlertColor, setFileAlert
} from '../../libs/todoSlice'
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

const validator = {
  address: "ที่อยู่",
  birth_date: "วันเกิด (ปปปป-ดด-วว)",
  cid: "เลขบัตรประชาชน",
  district: "อำเภอ",
  email: "อีเมล",
  index: "ลำดับ",
  name_eng: "ชื่อ (อังกฤษ)",
  name_th: "ชื่อ (ไทย)",
  nickname_eng: "ฉายา (อังกฤษ)",
  nickname_th: "ฉายา (ไทย)",
  password: "รหัสผ่าน (Password)",
  province: "จังหวัด",
  special_title_eng: "คำนำหน้า อื่นๆ (อังกฤษ)",
  special_title_th: "คำนำหน้า อื่นๆ (ไทย)",
  sub_district: "ตำบล",
  surname_eng: "นามสกุล (อังกฤษ)",
  surname_th: "นามสกุล (ไทย)",
  tel: "เบอร์โทรศัพท์",
  title_th: "คำนำหน้า (ไทย)",
  username: "ชื่อผู้ใช้งาน (Username)",
  zipcode: "รหัสไปรษณีย์",
  id_card_type: "ประเภทบัตร",
}

export default function ExcelImportPreRegisterEduTeacher() {
  const dispatch = useDispatch()
  const fileNameStore = useSelector(getFilename)
  const style = useSelector(getStyle)
  const navigate = useNavigate()
  const params = useParams()

  const showAlert = useSelector(getFileAlertShow)
  const alertMessage = useSelector(getFileAlertMessage)
  const alertColor = useSelector(getFileAlertColor)
  const { Dragger } = Upload;
  useEffect(() => {
    if (showAlert) {
      setTimeout(() => {
        dispatch(setFileAlert({
          file_alert_show: false,
          file_alert_color: '',
          file_alert_message: '',
        }))
      }, 3000)
    }
  }, [showAlert]);
  const readFile = (info) => {
    return new Promise((resolve, reject) => {
      const xlsx = require('xlsx')
      if (info) {
        const reader = new FileReader();
        reader.readAsArrayBuffer(info);
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = xlsx.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = xlsx.utils.sheet_to_json(worksheet);
          reader.json = json;
          resolve({ json: json, info: info })
        };
      } else {
        resolve({ json: [], info: info })
      }
    })
  }
  const onChange = async (e) => {
    const extension = e.name.split('.')?.[1]
    if (extension !== 'xlsx' && extension !== 'xls') {
      dispatch(setFileAlert({
        file_alert_show: true,
        file_alert_color: 'error',
        file_alert_message: 'ไฟล์ไม่ถูกต้อง',
      }))

      dispatch(setFile({
        file: [],
        filename: '',
        file_id: ''
      }))
    } else {
      const { json, info } = await readFile(e)
      await setStore(json, info)
    }
  }
  const objective = useSelector(getObjective)
  const checkCase = (json) => {
    const header = json[0]
    let valid = true
    for (const key in header) {
      if (Object.hasOwnProperty.call(header, key)) {
        if (!validator[key]) {
          valid = false
        }
      }
    }
    return valid
  }
  const business_id = useSelector(getBizID)
  const setStore = (json, info) => {
    const checked_json = json.filter((_, i) => i >= 1)
    if (json[1] === undefined || json[1] === null) {
      dispatch(setFileAlert({
        file_alert_show: true,
        file_alert_color: 'error',
        file_alert_message: 'ไฟล์ไม่ถูกต้อง',
      }))

      dispatch(setFile({
        file: [],
        filename: '',
        file_id: ''
      }))
    } else {
      if (json.length > 502) {
        dispatch(setFileAlert({
          file_alert_show: true,
          file_alert_color: 'error',
          file_alert_message: 'อัพโหลดครั้งละไม่เกิน 500 ข้อมูล',
        }))
        dispatch(setFile({
          file: [],
          filename: '',
          file_id: ''
        }))
      } else if (checkCase(json)) {
        dispatch(setFileAlert({
          file_alert_show: true,
          file_alert_color: 'success',
          file_alert_message: 'สำเร็จ',
        }))
        // console.log('checked_json :>> ', checked_json);
        dispatch(setFile({
          file: checked_json,
          filename: info.name,
        }))
        let formData = new FormData()
        formData.append('business_id', business_id)
        formData.append('excel', info)
        axios({
          method: 'POST',
          url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel`,
          data: formData,
        }).then(({ data, status }) => {
          dispatch(setFile({
            file: checked_json,
            filename: info.name,
            file_id: data.data._id
          }))
        }, ({ response }) => {
          const { status } = response
          if (status === 401) {
            navigate(`/${params.prefix}`)
          }
        })
      } else {
        // message.error('ไฟล์ไม่ถูกต้อง')
        dispatch(setFileAlert({
          file_alert_show: true,
          file_alert_color: 'error',
          file_alert_message: 'ไฟล์ไม่ถูกต้อง',
        }))
        dispatch(setFile({
          file: [],
          filename: '',
          file_id: ''
        }))
      }
    }
  }

  const downloadForm = () => {
    window.open('/files/templates/edu-teacher-pre-register.xlsx', '_blank');
  }

  return (
    <>
      <span>แบบฟอร์มเพิ่มรายชื่อ :
        <button
          onClick={downloadForm}
          style={{
            border: 'none',
            background: 'none'
          }}>
          {objective.map(o => { if (o === 'เลขที่หนังสือสัญญา') { return 'contract' } else { return o } }).join('-').toLowerCase().replaceAll(' ', '-')}.xlsx &nbsp;
          <Tooltip title={<span style={{ fontSize: '14px' }} >ดาวน์โหลดแบบฟอร์ม</span>} placement="right" >
            <DownloadIcon style={{ color: 'black' }} />
          </Tooltip>
        </button>
      </span>
      <br />
      <Dragger
        style={{
          display: 'none'
        }}
        accept={['.xlsx', '.xls', '.csv'].join(',')}
        beforeUpload={() => false}
        maxCount={1}
      >
        <p className="ant-upload-drag-icon">
          <CloudUploadOutlined />
        </p>
        <p className="ant-upload-text">ลากและวางเอกสารที่นี่</p>
        <p className="ant-upload-hint">
          หรือเลือกไฟล์ เฉพาะไฟล์ .xls และ .xlsx เท่านั้น
        </p>
      </Dragger>

      <FileUploader
        handleChange={onChange}
        style={{
          width: '100%',
        }}
        name="file"
        types={['xlsx', 'xls', 'csv']}
        children={<>
          <Dragger
            onClick={() => false}
            openFileDialogOnClick={false}
          >
            <p className="ant-upload-drag-icon">
              <CloudUploadOutlined style={{ color: style.primary_color ?? '#053075', }} />
            </p>
            <p className="ant-upload-text">ลากและวางเอกสารที่นี่</p>
            <p className="ant-upload-hint">
              หรือเลือกไฟล์ เฉพาะไฟล์ .xls และ .xlsx เท่านั้น
            </p>
          </Dragger>

        </>
        }
      />
      <span
        style={{
          color: 'red',
          fontSize: '14px'
        }}
      >
        *กรุณาอัปโหลดครั้งละไม่เกิน 500 รายชื่อ
      </span><br />
      {fileNameStore ? <><strong>Filename:</strong> {fileNameStore}</> : ''}
      {showAlert &&
        <Alert
          onClose={() => {
            dispatch(setFileAlert({
              file_alert_show: false,
              file_alert_color: '',
              file_alert_message: '',
            }))
          }}
          severity={alertColor}
        >
          {alertMessage}
        </Alert>
      }
    </>
  )
}